"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentSnapshotToObject = exports.querySnapshotToArray = void 0;
const querySnapshotToArray = (querySnapshot) => {
    if (!querySnapshot || querySnapshot.empty) {
        return [];
    }
    else {
        return querySnapshot.docs.map((doc) => (Object.assign({ id: doc.id }, doc.data())));
    }
};
exports.querySnapshotToArray = querySnapshotToArray;
const documentSnapshotToObject = (documentSnapshot) => {
    if (documentSnapshot.exists) {
        return Object.assign({ id: documentSnapshot.id }, documentSnapshot.data());
    }
    else {
        return {};
    }
};
exports.documentSnapshotToObject = documentSnapshotToObject;
//# sourceMappingURL=firestore.js.map